<ng-container [formGroup]="service.formGroup">
  <mat-form-field>
    <input
      matInput
      [matDatepicker]="picker"
      [formControlName]="question.getName()"
      placeholder="DD/MM/YYYY"
      aria-label="Enter date in DD/MM/YYYY format"
    />
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
  </mat-form-field>
</ng-container>
